import React from 'react';
import UserForm from "src/components/account/UserForm";
import {Typography} from "@mui/material";
import {Link} from "react-router-dom";
import Box from "@mui/material/Box";

const RegisterPage = () => {

  return (
    <>
      <Typography variant="h2" mb={2}>Registreren</Typography>
      <Typography variant="body1" mb={2}>
        Via onderstaand formulier kun je jezelf aanmelden als deelnemer bij Senso.
      </Typography>

      <Box mb={2}>
        <UserForm register={true} />
      </Box>

      <p><Link to="/login">Inloggen</Link></p>
    </>
  );
}

export default RegisterPage;

RegisterPage.propTypes = {}

RegisterPage.defaultProps = {}